import { DialogResponseMessageType } from "@lib/enum"
import { L, LNotification } from "@lib/abpUtility"
import { notifySuccess, notifyWarning } from "@lib/helper"

/** Normalize API result → DialogResponseMessageType (missing field = legacy success). */
export function getBookingInvitationPickProductMessageType(result: any): DialogResponseMessageType {
  const raw = result?.messageType ?? result?.MessageType
  if (raw === undefined || raw === null || raw === "") {
    return DialogResponseMessageType.SUCCESS
  }
  const n = Number(raw)
  return Number.isNaN(n) ? DialogResponseMessageType.SUCCESS : (n as DialogResponseMessageType)
}

export function isBookingInvitationPickProductSuccess(result: any): boolean {
  return getBookingInvitationPickProductMessageType(result) === DialogResponseMessageType.SUCCESS
}

function resolvedDescription(result: any, messageType: DialogResponseMessageType): string {
  const server =
    result?.message ??
    result?.Message ??
    result?.errorMessage ??
    result?.ErrorMessage ??
    result?.error?.message
  if (typeof server === "string" && server.trim()) {
    return server.trim()
  }
  switch (messageType) {
    case DialogResponseMessageType.SUCCESS:
      return LNotification("UPDATE_SUCCESSFULLY")
    case DialogResponseMessageType.BOOKINGISPICKED:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_BOOKING_ALREADY_PICKED")
    case DialogResponseMessageType.PRODUCTISPICKED:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_PRODUCT_ALREADY_PICKED")
    case DialogResponseMessageType.SALESEVENTISEXPIRED:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_SALE_EVENT_EXPIRED")
    case DialogResponseMessageType.PICKPRODUCTOVERLIMIT:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_OVER_LIMIT")
    case DialogResponseMessageType.QUOTALIMITEXHAUSTED:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_QUOTA_EXHAUSTED")
    case DialogResponseMessageType.PRICECHANGED:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_PRICE_CHANGED")
    default:
      return L("DIALOG_RESPONSE_PICK_PRODUCT_UNKNOWN")
  }
}

/** Show toast from BookingInvitationPickProduct response; call after HTTP success. */
export function notifyBookingInvitationPickProductResult(result: any): void {
  const messageType = getBookingInvitationPickProductMessageType(result)
  const description = resolvedDescription(result, messageType)

  if (messageType === DialogResponseMessageType.SUCCESS) {
    notifySuccess(LNotification("SUCCESS"), description)
    return
  }

  notifyWarning(L("DIALOG_RESPONSE_PICK_PRODUCT_NOTIFY_TITLE"), description)
}
